export const PULSELEADS_MARKETING_LEAD_LIMIT_RULE_TITLE = 'title.pulseleadsRule.marketingLeadLimit';
export const PULSELEADS_MARKETING_LEAD_LIMIT_RULE_PATH = '/marketingLeadLimit';
export const PULSELEADS_MARKETING_LEAD_LIMIT_RULE_NAMESPACE = 'PULSELEADS-MARKETING-LEAD-LIMIT-RULE';
